import type * as NEA from '@spendesk/general-type-helpers/NonEmptyArray';

import { useMutation } from 'src/core/api/hooks/useMutation';

import { getPayableRulesQueryKey } from './useGetPayableRules';

type SendMissingDocumentaryEvidencesReminderError =
  | {
      reason: 'invalidBodyParams';
      error: Error;
    }
  | { reason: 'unauthorized' | 'bookkeepingApiNotFound' | 'nothingToRemind' };

type SendMissingDocumentaryEvidencesReminderResponse = {
  reminderSent: true;
};
// TODO: better types, reuse other types
export type CreatePayableRulePayload = {
  conditions: NEA.NonEmptyArray<{
    field: string;
    operator: string;
    value: [string, ...string[]] | 'all' | null | undefined | unknown;
  }>;
  outputs: NEA.NonEmptyArray<{
    [key: string]: string | { [key: string]: string };
  }>;
  icon: string;
  state: 'draft' | 'published';
  name: string;
};

export const useCreatePayableRule = () => {
  return useMutation<
    CreatePayableRulePayload,
    SendMissingDocumentaryEvidencesReminderResponse,
    SendMissingDocumentaryEvidencesReminderResponse,
    SendMissingDocumentaryEvidencesReminderError
  >({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/bookkeeping/automation/payable-rules',
      method: 'post',
    },
    options: {
      throwOnError: true,
      onSuccess: ({ client }) => {
        client.invalidateQueries(getPayableRulesQueryKey);
      },
    },
    reshapeData(data) {
      return data;
    },
  });
};
